import { http } from "../framework/api";
import config from "../config";

import {
  GET_MATERIALS_LOADING,
  GET_MATERIALS_LOADING_SUCCESSFUL,
  GET_MATERIALS_LOADING_FAIL,
  GET_SESSIONS_LOADING,
  GET_SESSIONS_LOADING_SUCCESSFUL,
  GET_SESSIONS_LOADING_FAIL,
  GET_REQUEST_LOADING,
  GET_REQUEST_LOADING_SUCCESSFUL,
  GET_REQUEST_LOADING_FAIL,
  GET_SUBMITTED_LOADING,
  GET_SUBMITTED_LOADING_SUCCESSFUL,
  GET_SUBMITTED_LOADING_FAIL,
  SEND_REQUEST_LOADING,
  SEND_REQUEST_LOADING_SUCCESSFUL,
  SEND_REQUEST_LOADING_FAIL,
  TIME_ZONE_MODAL_OPEN,
  TIME_ZONE_MODAL_CLOSE,
  GET_ASSESSMENTS_SUCCESS,
  GET_ASSESSMENTS_FAIL,
  REQUEST_MODAL_OPEN,
  REQUEST_MODAL_CLOSE,
  ASSESSMENT_MODAL_OPEN,
  ASSESSMENT_MODAL_CLOSE,
  TEXT_MESSAGES_MODAL_OPEN,
  TEXT_MESSAGES_MODAL_CLOSE,
  CHECK_SMS_STATUS,
  CHECK_SMS_STATUS_SUCCESSFUL,
  CHECK_SMS_STATUS_FAIL,
  SET_SMS_DATA,
  SET_SMS_DATA_SUCCESSFUL,
  SET_SMS_DATA_FAIL,
  CHECK_SMS_VERIFICATION_CODE,
  CHECK_SMS_VERIFICATION_CODE_SUCCESSFUL,
  CHECK_SMS_VERIFICATION_CODE_FAIL,
  DISCLAIMER_MODAL_OPEN,
  DISCLAIMER_MODAL_CLOSE,
  SET_SECONDS_LEFT,
} from "../reducers/portal.reducer";

export const getSessions = (lang) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({
      type: GET_SESSIONS_LOADING,
      payload: [],
    });
    let url = `${config.API_ROOT_URL}/sessions/my?lang=${lang}`;

    http("GET", url, null)
      .then(function (res) {
        dispatch({
          type: GET_SESSIONS_LOADING_SUCCESSFUL,
          payload: res,
        });
        resolve(res);
      })
      .catch(function (res) {
        dispatch({
          type: GET_SESSIONS_LOADING_FAIL,
          payload: res,
        });
        reject(res);
      });
  });

export const getMaterials = (lang) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({
      type: GET_MATERIALS_LOADING,
      payload: [],
    });
    let url = `${config.API_ROOT_URL}/materials/my?lang=${lang}`;

    http("GET", url, null)
      .then(function (res) {
        dispatch({
          type: GET_MATERIALS_LOADING_SUCCESSFUL,
          payload: res,
        });
        resolve(res);
      })
      .catch(function (res) {
        dispatch({
          type: GET_MATERIALS_LOADING_FAIL,
          payload: res,
        });
        reject(res);
      });
  });

export const getRequest = (lang) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({
      type: GET_REQUEST_LOADING,
      payload: [],
    });
    let url = `${config.API_ROOT_URL}/clientRequest/clientReviewSingleResponse?lang=${lang}`;

    http("GET", url, null)
      .then(function (res) {
        dispatch({
          type: GET_REQUEST_LOADING_SUCCESSFUL,
          payload: res,
        });
        resolve(res);
      })
      .catch(function (res) {
        dispatch({
          type: GET_REQUEST_LOADING_FAIL,
          payload: res,
        });
        reject(res);
      });
  });

export const getSubmitted = () => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({
      type: GET_SUBMITTED_LOADING,
      payload: [],
    });
    let url = `${config.API_ROOT_URL}/clientRequest/clientViewSubmittedResponse`;

    http("GET", url, null)
      .then(function (res) {
        dispatch({
          type: GET_SUBMITTED_LOADING_SUCCESSFUL,
          payload: res,
        });
        resolve(res);
      })
      .catch(function (res) {
        dispatch({
          type: GET_SUBMITTED_LOADING_FAIL,
          payload: res,
        });
        reject(res);
      });
  });

export const sendRequest = (selectedGroups) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({
      type: SEND_REQUEST_LOADING,
      payload: [],
    });
    let url = `${config.API_ROOT_URL}/clientRequest/submitClientResponse`;
    let data = { selectedGroups: selectedGroups };

    http("PUT", url, data)
      .then(function (res) {
        dispatch({
          type: SEND_REQUEST_LOADING_SUCCESSFUL,
          payload: res,
        });
        resolve(res);
      })
      .catch(function (res) {
        dispatch({
          type: SEND_REQUEST_LOADING_FAIL,
          payload: res,
        });
        reject(res);
      });
  });

export const openRequestModal = () => (dispatch) => {
  dispatch({
    type: REQUEST_MODAL_OPEN,
    payload: true,
  });
};

export const openAssessmentModal = () => (dispatch) => {
  dispatch({
    type: ASSESSMENT_MODAL_OPEN,
    payload: true,
  });
};

export const openTextMessagesModal = () => (dispatch) => {
  dispatch({
    type: TEXT_MESSAGES_MODAL_OPEN,
    payload: true,
  });
};

export const closeRequestModal = () => (dispatch) => {
  dispatch({
    type: REQUEST_MODAL_CLOSE,
    payload: false,
  });
};
export const closeAssessmentsModal = () => (dispatch) => {
  dispatch({
    type: ASSESSMENT_MODAL_CLOSE,
    payload: false,
  });
};
export const closeTextMessagesModal = () => (dispatch) => {
  dispatch({
    type: TEXT_MESSAGES_MODAL_CLOSE,
    payload: false,
  });
};

export const openDisclaimerModal = () => (dispatch) => {
  dispatch({
    type: DISCLAIMER_MODAL_OPEN,
    payload: true,
  });
};

export const closeDisclaimerModal = () => (dispatch) => {
  dispatch({
    type: DISCLAIMER_MODAL_CLOSE,
    payload: false,
  });
};

export const checkGroupAvailabilityMultiple =
  (startWeek, treatmentId, enrolledAccountGroupId, selectedLang) =>
  (dispatch) =>
    new Promise((resolve, reject) => {
      dispatch({
        type: GET_REQUEST_LOADING,
        payload: [],
      });
      let url = `${config.API_ROOT_URL}/clientRequest/checkgroupavailabilitymultiple?treatmentId=${treatmentId}&startWeek=${startWeek}&enrolledAccountGroupId=${enrolledAccountGroupId}&selectedLang=${selectedLang}`;
      http("GET", url, null)
        .then(function (res) {
          dispatch({
            type: GET_REQUEST_LOADING_SUCCESSFUL,
            payload: res,
          });
          resolve(res);
        })
        .catch(function (res) {
          dispatch({
            type: GET_REQUEST_LOADING_FAIL,
            payload: res,
          });
          reject(res);
        });
    });
export const getAssessments = () => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({
      type: GET_MATERIALS_LOADING,
      payload: [],
    });
    let url = `${config.API_ROOT_URL}/assessments/my`;

    http("GET", url, null)
      .then((res) => {
        dispatch({
          type: GET_ASSESSMENTS_SUCCESS,
          payload: res,
        });
        resolve(res);
      })
      .catch((error) => {
        dispatch({
          type: GET_ASSESSMENTS_FAIL,
          payload: error?.response || error,
        });
        reject(error);
      });
  });

export const checkSmsStatus = (userId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({
      type: CHECK_SMS_STATUS,
      payload: [],
    });
    let url = `${config.API_ROOT_URL}/accounts/checksmsstatus?userId=${userId}`;
    http("GET", url)
      .then(function (res) {
        dispatch({
          type: CHECK_SMS_STATUS_SUCCESSFUL,
          payload: res,
        });
        resolve(res);
      })
      .catch(function (res) {
        dispatch({
          type: CHECK_SMS_STATUS_FAIL,
          payload: res,
        });
        reject(res);
      });
  });

export const setSmsData = (request) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({
      type: SET_SMS_DATA,
      payload: [],
    });
    let url = `${config.API_ROOT_URL}/accounts/setsmsdata`;
    http("POST", url, request)
      .then(function (res) {
        dispatch({
          type: SET_SMS_DATA_SUCCESSFUL,
          payload: res,
        });
        resolve(res);
      })
      .catch(function (res) {
        dispatch({
          type: SET_SMS_DATA_FAIL,
          payload: res,
        });
        reject(res);
      });
  });

  export const setSecondsLeft = (seconds) => ({
    type: SET_SECONDS_LEFT,
    payload: seconds,
  });

  export const resetSecondsLeft = () => ({
    type: SET_SECONDS_LEFT,
    payload: null,
  });
